import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import {
  createEntradaEstoque,
  updateEntradaEstoque,
  entradaPodeSerEditadaExcluida,
  attachFiles,
  deleteAttachFiles,
  attachFilesToContaPagar,
  deleteAttachFilesFromContaPagar,
} from '../service';
import {
  CREATE_ENTRADA_ESTOQUE,
  CREATE_ENTRADA_ESTOQUE_PENDING,
  CREATE_ENTRADA_ESTOQUE_SUCCESS,
  CREATE_ENTRADA_ESTOQUE_FAILURE,
  CONFIG_SESSION,
} from '@handler';
import { storage } from '@commons/storage';
import { AlertSuccess, AlertError, AlertWarning } from '@components/common/AlertToast';
import { formatJsonRemoveEmptyOrNull } from '@components/common/format';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateEntradaEstoque(action) {
  yield put({ type: CREATE_ENTRADA_ESTOQUE_PENDING });
  
  // Verificação de segurança
  if (!action || !action.data) {
    yield put({ type: CREATE_ENTRADA_ESTOQUE_FAILURE, registro: null });
    AlertError('Dados da entrada não encontrados!');
    return;
  }
  
  var processar = true;
  if (action.data.id !== undefined && action.data.id !== null) {
    processar = yield call(entradaPodeSerEditadaExcluida, action.data.id);
  }
  
  if (processar) {
    try {
      if (!action.data.lancaProduto) {
        action.data.itens = [];
      }
      if (!action.data.movimentaEstoque) {
        action.data.localEstoque = null;
      }
      
      // Verificação de segurança para entradaDup
      if (!action.data.entradaDup) {
        action.data.entradaDup = {};
      }
      
      // Verificação de segurança para parcelas
      if (!action.data.parcelas) {
        action.data.parcelas = [];
      }
      
      if (!action.data.entradaDup.geraDuplicata) {
        action.data.entradaDup.tipoDuplicata = null;
        action.data.entradaDup.contaGerencial = null;
        action.data.entradaDup.centroCusto = null;
        action.data.entradaDup.historico = '';
        action.data.entradaDup.tipoPagamento = null;
        action.data.entradaDup.contaCaixa = null;
        action.data.entradaDup.contaBanco = null;
        action.data.entradaDup.numeroParcelas = null;
        action.data.parcelas = [];
      } else if (action.data.entradaDup.geraDuplicata) {
        if (action.data.entradaDup.tipoDuplicata === 'A_VISTA') {
          action.data.entradaDup.numeroParcelas = null;
          action.data.parcelas = [];
          if (action.data.entradaDup.movimentaFinanceiro === false) {
            action.data.entradaDup.contaGerencial = null;
            action.data.entradaDup.centroCusto = null;
            action.data.entradaDup.historico = '';
            action.data.entradaDup.tipoPagamento = null;
            action.data.entradaDup.contaCaixa = null;
            action.data.entradaDup.contaBanco = null;
          }
        } else if (action.data.entradaDup.tipoDuplicata === 'PARCELADA' && action.data.entradaDup.movimentaFinanceiro === false) {
          if (action.data.parcelas && action.data.parcelas.length > 0) {
            for (var i = 0; i < action.data.parcelas.length; i++) {
              action.data.parcelas[i].contaGerencial = null;
              action.data.parcelas[i].centroCusto = null;
              action.data.parcelas[i].historico = '';
              action.data.parcelas[i].parcelaPaga = false;
              action.data.parcelas[i].tipoPagamento = null;
              action.data.parcelas[i].contaCaixa = null;
              action.data.parcelas[i].contaBanco = null;
            }
          }
        }
      }
      
      if (action.data.vincularPatrimonio === undefined || action.data.vincularPatrimonio === null || !action.data.vincularPatrimonio) {
        action.data.patrimonio = null;
      }
      
      // Coleta informações sobre anexos e duplicatas
      let anexosInfo = [];
      
      if (action.data.entradaDup && action.data.entradaDup.geraDuplicata && action.data.entradaDup.movimentaFinanceiro) {
        // Para duplicata à vista
        if (action.data.entradaDup.tipoDuplicata === 'A_VISTA') {
          const temArquivosUpload = action.data.entradaDup.filesToUploadList && 
                                   action.data.entradaDup.filesToUploadList.length > 0;
          const temArquivosDelete = action.data.entradaDup.filesToDeleteList && 
                                   action.data.entradaDup.filesToDeleteList.length > 0;
          
          if (temArquivosUpload || temArquivosDelete) {
            anexosInfo.push({
              tipo: 'A_VISTA',
              historico: action.data.entradaDup.historico || '',
              files: action.data.entradaDup.filesToUploadList || [],
              filesToDelete: action.data.entradaDup.filesToDeleteList || []
            });
          }
        } 
        // Para duplicatas parceladas
        else if (action.data.entradaDup.tipoDuplicata === 'PARCELADA' && action.data.parcelas && action.data.parcelas.length > 0) {
          for (let index = 0; index < action.data.parcelas.length; index++) {
            const parcela = action.data.parcelas[index];
            
            const parcelaHistorico = (parcela.historico || '') + ` - Parc. ${index + 1}/${action.data.parcelas.length}`;
            action.data.parcelas[index].historico = parcelaHistorico;
            
            // CORREÇÃO: Incluir parcelas que tenham arquivos para upload OU para deletar
            const temArquivosUpload = parcela.filesToUploadList && parcela.filesToUploadList.length > 0;
            const temArquivosDelete = parcela.filesToDeleteList && parcela.filesToDeleteList.length > 0;
            
            if (parcela.anexarDoc && (temArquivosUpload || temArquivosDelete)) {
              anexosInfo.push({
                tipo: 'PARCELADA',
                index: index,
                numeroParcelaTxt: `Parc. ${index + 1}/${action.data.parcelas.length}`,
                historico: parcelaHistorico,
                files: parcela.filesToUploadList || [], // Pode ser vazio se só tem arquivos para deletar
                filesToDelete: parcela.filesToDeleteList || []
              });
            }
          }
        }
      }

      // **CORREÇÃO: Criar uma cópia limpa dos dados sem os arquivos de anexo**
      const dadosParaEnvio = { ...action.data };
      
      // Remove arquivos da duplicata à vista
      if (dadosParaEnvio.entradaDup) {
        const { filesToUploadList, filesToDeleteList, anexarDoc, ...entradaDupLimpa } = dadosParaEnvio.entradaDup;
        dadosParaEnvio.entradaDup = entradaDupLimpa;
      }
      
      // Remove arquivos das parcelas
      if (dadosParaEnvio.parcelas && dadosParaEnvio.parcelas.length > 0) {
        dadosParaEnvio.parcelas = dadosParaEnvio.parcelas.map(parcela => {
          const { filesToUploadList, filesToDeleteList, anexarDoc, ...parcelaLimpa } = parcela;
          return parcelaLimpa;
        });
      }
      
      // Criação ou atualização da entrada de estoque
      if (action.data.id === undefined || action.data.id === null) {
        // CRIAÇÃO DE NOVA ENTRADA
        const resp = yield call(createEntradaEstoque, formatJsonRemoveEmptyOrNull({
          ...dadosParaEnvio, // Usando dados limpos sem arquivos
          propriedade: {
            id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
          }
        }));
        trackingEventCX('action', MODULE_ACTIONS_ENUM.ENTRADA_NF_CRIAR);
        
        if (resp.status == 201) {
          // Anexar arquivos à nota principal
          if (action.filesToAttach && action.filesToAttach.length > 0) {
            yield call(attachFiles, resp.data.id, action.filesToAttach);
            trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
          }
          
          // Processar anexos para duplicatas
          if (anexosInfo.length > 0 && resp.data.lancamentosContaPagar) {
            const lancamentos = resp.data.lancamentosContaPagar || [];
            
            // Para cada informação de anexo, encontrar o lancamento correspondente
            for (const anexo of anexosInfo) {
              let contaPagarId = null;
              
              // Tenta encontrar o lancamento correspondente com base no historico
              for (const lancamento of lancamentos) {
                if (anexo.tipo === 'A_VISTA') {
                  // Para à vista, procuramos por um historico que corresponda exatamente
                  if (lancamento.historico === anexo.historico) {
                    contaPagarId = lancamento.id; // Este é o ID retornado
                    break;
                  }
                } else if (anexo.tipo === 'PARCELADA') {
                  // Para parcelada, procuramos por um historico que contenha o texto da parcela
                  if (lancamento.historico && lancamento.historico.includes(anexo.numeroParcelaTxt)) {
                    contaPagarId = lancamento.id; // Este é o ID retornado
                    break;
                  }
                }
              }
              
              // Se não encontramos pelo histórico e é uma duplicata À VISTA com apenas um lancamento
              if (!contaPagarId && anexo.tipo === 'A_VISTA' && lancamentos.length === 1) {
                contaPagarId = lancamentos[0].id; // Pega o único lançamento criado
              }
              
              // Se ainda não encontramos mas é uma duplicata PARCELADA e temos o mesmo número de lancamentos
              if (!contaPagarId && anexo.tipo === 'PARCELADA' && 
                  action.data.parcelas && lancamentos.length === action.data.parcelas.length) {
                // Usa o índice da parcela para pegar o lancamento correspondente
                contaPagarId = lancamentos[anexo.index].id;
              }
              
              // Se encontramos um ID, anexa os arquivos usando o ID do conta a pagar retornado
              if (contaPagarId) {
                if (anexo.files && anexo.files.length > 0) {
                  // Agora anexa os arquivos ao conta a pagar específico usando seu ID
                  yield call(attachFilesToContaPagar, contaPagarId, anexo.files);
                  trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
                }
              }
            }
          }
        }
      } else {
        // ATUALIZAÇÃO DE ENTRADA EXISTENTE
        let lancamentosContaPagar = [];
        if (action.data.lancamentosContaPagar && action.data.lancamentosContaPagar.length > 0) {
          action.data.lancamentosContaPagar.forEach(element => {
            lancamentosContaPagar = [
              ...lancamentosContaPagar,
              {
                "forJson": "contapagar",
                "id": element.id,
                "valor": element.valor,
                "historico": element.historico,
                "propriedade": { "id": element.propriedade.id },
                "contaGerencial": {
                  "id": element.contaGerencial.id,
                  "tipoConta": "A"
                }
              }
            ]
          });
        }
        
        const resp = yield call(updateEntradaEstoque,
          {
            ...dadosParaEnvio, // Usando dados limpos sem arquivos
            lancamentosContaPagar: lancamentosContaPagar,
            id: action.data.id
          }
        );
        trackingEventCX('action', MODULE_ACTIONS_ENUM.ENTRADA_NF_EDITAR);
        
        // Anexar/deletar arquivos da nota principal
        if (action.filesToAttach && action.filesToAttach.length > 0) {
          yield call(attachFiles, action.data.id, action.filesToAttach);
          trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
        }
        if (action.filesIdToDelete && action.filesIdToDelete.length > 0) { 
          yield call(deleteAttachFiles, action.data.id, action.filesIdToDelete); 
        }
        
        // Processar anexos para duplicatas no caso de atualização
        if (resp && resp.lancamentosContaPagar && resp.lancamentosContaPagar.length > 0) {
          const lancamentos = resp.lancamentosContaPagar || [];
          
          // Para cada informação de anexo, encontrar o lancamento correspondente usando os NOVOS IDs
          for (const anexo of anexosInfo) {
            let contaPagarId = null;
            
            // Tenta encontrar o lancamento correspondente com base no historico
            for (const lancamento of lancamentos) {
              if (anexo.tipo === 'A_VISTA') {
                if (lancamento.historico === anexo.historico) {
                  contaPagarId = lancamento.id; // NOVO ID retornado pela API
                  break;
                }
              } else if (anexo.tipo === 'PARCELADA') {
                if (lancamento.historico && lancamento.historico.includes(anexo.numeroParcelaTxt)) {
                  contaPagarId = lancamento.id; // NOVO ID retornado pela API
                  break;
                }
              }
            }
            
            // Fallback: Se não encontramos pelo histórico, tentamos mapear por índice
            if (!contaPagarId && anexo.tipo === 'A_VISTA' && lancamentos.length === 1) {
              contaPagarId = lancamentos[0].id; // NOVO ID retornado pela API
            }
            
            if (!contaPagarId && anexo.tipo === 'PARCELADA' && 
                action.data.parcelas && lancamentos.length === action.data.parcelas.length) {
              contaPagarId = lancamentos[anexo.index].id; // NOVO ID retornado pela API
            }
            
            // Se encontramos um ID (NOVO da API), anexa/remove os arquivos
            if (contaPagarId) {
              if (anexo.files && anexo.files.length > 0) {
                yield call(attachFilesToContaPagar, contaPagarId, anexo.files);
                trackingEventCX('action', MODULE_ACTIONS_ENUM.FILE_STORAGE);
              }
              if (anexo.filesToDelete && anexo.filesToDelete.length > 0) {
                yield call(deleteAttachFilesFromContaPagar, contaPagarId, anexo.filesToDelete);
              }
            }
          }
        }
      }
      
      yield put({ type: CREATE_ENTRADA_ESTOQUE_SUCCESS, registro: action.data });
      history.push('/financeiro/entradaNota');
      AlertSuccess('Entrada registrada com sucesso!');
    } catch (error) {
      yield put({ type: CREATE_ENTRADA_ESTOQUE_FAILURE, registro: action.data });

      // Verificar se é erro 422 com mensagem específica do backend
      const errorStatus = error?.response?.status || error?.status;
      const errorMessage = error?.response?.data?.text || error?.response?.data?.message || error?.data?.message;

      if (errorStatus === 422 && errorMessage) {
        // Mostrar mensagem específica do backend para erro 422
        AlertWarning(errorMessage);
      } else {
        // Mostrar mensagem padrão para outros erros
        AlertError('Falha ao salvar a entrada! Tente novamente...');
      }
    }
  } else {
    yield put({ type: CREATE_ENTRADA_ESTOQUE_FAILURE, registro: action.data });
    AlertWarning('Entrada não pode ser editada, pois já houve movimentação no estoque');
  }
}

export default function* watchCreateEntradaEstoque() {
  yield takeLatest(CREATE_ENTRADA_ESTOQUE, sagaCreateEntradaEstoque);
}
